module.exports = __webpack_public_path__ + "img/BECTON DICKINSON.518ebcb9.jpg";